// Generated from Soul_Radar_FAQ_final_2026-09_ENG.docx – do not edit copy by hand
export const FAQ_INTRO = "Everything you need to know about accounts, events, DJs, “I’m going”, calendars, messages, support, Top Events and the Event Archive.";
export const FAQ = [
 {
  "title": "Using Soul Radar & Your Account",
  "items": [
   {
    "q": "Do I need an account to use Soul Radar?",
    "a": "No. You can browse Soul Radar and discover events without an account. You only need an account for personal features such as saving events, using “I’m going”, submitting your own events, creating a DJ profile or sending messages."
   },
   {
    "q": "How do I sign up for Soul Radar?",
    "a": "Open the sign-up page from the account/profile area and follow the registration steps. Once you’re signed up, you can manage your personal features and profiles."
   },
   {
    "q": "What do I need to sign up?",
    "a": "You’ll need a valid email address and the information requested during registration. Use an email address you’ll continue to have access to so you don’t miss important messages about your account or submitted events."
   },
   {
    "q": "Do I need to accept the Terms of Use and Privacy Policy when I sign up?",
    "a": "Yes. You can only complete registration after actively agreeing to the Terms of Use and acknowledging the Privacy Policy. The checkbox is not pre-selected."
   },
   {
    "q": "Why should I create an account?",
    "a": "An account lets you get more out of Soul Radar: you can save events you’re interested in, mark events with “I’m going”, submit and manage your own events and, where available, exchange messages. DJs can also create their own DJ profile."
   },
   {
    "q": "I’ve forgotten my password. What should I do?",
    "a": "Use the password reset option on the sign-in page. We’ll send the next steps to the email address linked to your account."
   },
   {
    "q": "Can I change my email address or profile details?",
    "a": "Yes. You can update editable account and profile details in your settings or profile editor. If something cannot be changed directly for security reasons, please contact Support."
   },
   {
    "q": "How do I delete my account?",
    "a": "You’ll find the delete option in your profile settings. After selecting it, you’ll be asked to confirm that you want to permanently delete your account. Your profile, saved events and “I’m going” activity will be removed. Events that have already been published will remain on Soul Radar."
   },
   {
    "q": "What happens to my data when I delete my account?",
    "a": "Your personal account and profile data will be deleted or otherwise handled in accordance with the applicable data protection rules. Published events remain part of the event history. Any DJ profile linked to your account will be deactivated; previous event credits may remain, but without an active profile link. See the Privacy Policy for details."
   }
  ]
 },
 {
  "title": "Finding & Discovering Events",
  "items": [
   {
    "q": "What are the buttons below the search bar for?",
    "a": "The quick filters let you narrow down the event list instantly. They’re grouped by purpose: time, location, event type and music style — for example “This weekend”, “Near me”, “Alldayer / Allnighter / Weekender” and “Northern Soul / Modern Soul”. Active filters are clearly shown and can be removed at any time."
   },
   {
    "q": "How do I search for a specific event?",
    "a": "Use the search bar and enter the event name, location, organizer or another relevant search term. You can then use the filters to narrow down the results."
   },
   {
    "q": "Why can’t I see certain events?",
    "a": "First check your active filters, selected time period and, where applicable, your distance setting. Submitted events only become visible once they’ve been approved. Cancelled or past events may also be displayed differently or hidden depending on the view."
   },
   {
    "q": "How can I tell if an event has been cancelled or postponed?",
    "a": "Cancelled events are clearly marked “Cancelled” and visually greyed out. Postponed events are marked “Postponed”. Once a new date has been confirmed and added, it will also be clearly displayed."
   },
   {
    "q": "Can I view past events?",
    "a": "Yes. Events that have taken place remain available in the Event Archive, where you can browse and filter past events. Cancelled events are not included in the archive as events that actually took place."
   }
  ]
 },
 {
  "title": "Submitting Events",
  "items": [
   {
    "q": "How do I submit an event?",
    "a": "Only organizers or people authorized by the organizer may submit events. Sign in, select “Submit Event” and enter all required details, including the event name, date, time, location, description and flyer. Before submitting, you must confirm that you are the organizer or an authorized representative, that the information is accurate to the best of your knowledge, and that you have permission to use the uploaded content. Only then can the event be submitted for review."
   },
   {
    "q": "Do I need a special organizer profile?",
    "a": "No. You don’t need a special organizer account. A standard Soul Radar account is enough. When submitting an event, however, you must confirm that you are the organizer or have been authorized by the organizer to submit it."
   },
   {
    "q": "I’m not the organizer, but I know about an event near me that I’d like to add. Can I submit it?",
    "a": "No. Events may only be submitted by the organizer or someone they have authorized. If you’ve discovered an event, you can still share it with others or let the organizer know about Soul Radar."
   },
   {
    "q": "I’m not the organizer but I submitted an event anyway. Is that allowed?",
    "a": "No. When submitting an event, you must explicitly confirm that you are the organizer or are authorized to submit it. Unauthorized submissions may be rejected or removed."
   },
   {
    "q": "Why do I have to upload a flyer?",
    "a": "A flyer is required for every event on Soul Radar. It makes events easy to recognize at a glance and, especially in the soul scene, is an important part of event culture. Please upload the official flyer, or the flyer actually being used to promote the event. Information on the flyer does not replace the event details entered in the relevant fields."
   },
   {
    "q": "What if there isn’t a flyer?",
    "a": "At the moment, an event cannot be submitted without a flyer. Please wait until an official flyer, or the flyer being used for the event, is available before submitting it."
   },
   {
    "q": "What information does an event need to include?",
    "a": "At a minimum, an event needs a clear name, date, location and the key times visitors need to know. You should also include a short description, flyer, organizer, DJs, ticket or admission details and, where available, an official link for more information."
   },
   {
    "q": "Can I add multiple dates for an event series?",
    "a": "Yes. Each confirmed date should be added as a separate event. For a Weekender, you can also enter a start and end date as well as start and end times so multi-day events are displayed correctly."
   },
   {
    "q": "My event is happening again this year. Can I submit it again?",
    "a": "Yes. Create a new event for the new date, or use an existing reuse/duplicate option if one is available. Be sure to check the date, time, venue, DJs, description and flyer. Don’t carry over last year’s details without reviewing them."
   },
   {
    "q": "Can I submit the same event more than once?",
    "a": "No. There should only be one listing for the same event date. Soul Radar may flag a possible duplicate when you submit an event. Check the suggested match first; the warning does not automatically prevent you from continuing."
   },
   {
    "q": "Can I add a ticket link or event website?",
    "a": "Yes, if the submission form includes a field for it. Wherever possible, use the official ticket or event link rather than redirects or misleading links."
   },
   {
    "q": "Can I submit an event before all the details are confirmed?",
    "a": "Only if the essential details are already confirmed. The date, location and other key information must not be speculative. Optional details can be added later. A flyer is also required before the event can be submitted."
   },
   {
    "q": "Are there special fields for Weekenders, Live Shows or Record Fairs?",
    "a": "Yes. Weekenders include an additional end-date field. “Artists / Live Acts” only appears when the event type is “Live Show”. For a “Record Fair”, you can also add registration details: an email address or URL, plus a free-text field explaining how to register."
   }
  ]
 },
 {
  "title": "Review & Publication",
  "items": [
   {
    "q": "Why hasn’t my event been published?",
    "a": "Newly submitted events are reviewed before they are published. This helps maintain the quality of the event information and reduces duplicates, spam and incorrect listings. While the review is in progress, the event will not be publicly visible."
   },
   {
    "q": "How long does event approval take?",
    "a": "Approval is not necessarily immediate. Soul Radar aims to review events as promptly as possible, but cannot guarantee a specific turnaround time. Please submit your event well in advance whenever possible."
   },
   {
    "q": "Can my event be rejected?",
    "a": "Yes. An event may be rejected because details are incomplete or clearly incorrect, the event is a duplicate, it does not fit Soul Radar’s focus, or the submission contains spam or other problematic content. Where possible, you’ll be told what needs to be corrected."
   },
   {
    "q": "Can I correct a rejected event and resubmit it?",
    "a": "Yes, as long as the reason for rejection can be addressed. Correct the relevant details and submit the event for review again."
   },
   {
    "q": "Why are events moderated?",
    "a": "Moderation helps ensure that users see event information that is as reliable as possible. It is not a guarantee that every detail will remain accurate over time, so organizers and authorized submitters should update changes promptly."
   }
  ]
 },
 {
  "title": "Editing, Postponing or Cancelling Your Events",
  "items": [
   {
    "q": "Can I edit an event?",
    "a": "Yes. If you created the event and have the appropriate permissions, you can edit it from your event management area. Significant changes may be reviewed again before they become publicly visible."
   },
   {
    "q": "How do I delete my event?",
    "a": "Open the event in your event management area and use the delete option. If the event has already been published and is no longer taking place, marking it as “Cancelled” is usually better than deleting it completely, as this lets users who saved the event see what happened."
   },
   {
    "q": "My event has been cancelled. What should I do?",
    "a": "Mark the event as “Cancelled” rather than simply deleting it. This makes it immediately clear that the event is no longer taking place. “I’m going” is disabled for cancelled events."
   },
   {
    "q": "My event has been postponed. What should I do?",
    "a": "Use “Postpone Event / Postponed”. You can enter a new date if one has been confirmed, but you don’t need to have one yet. Until a new date is known, the event remains marked “Postponed” and “I’m going” is disabled. Once the replacement date is confirmed, you can update the event details."
   },
   {
    "q": "I didn’t create an event, but I’ve spotted incorrect information. What can I do?",
    "a": "Use the report function and explain as clearly as possible which information is incorrect. If you are the actual organizer, you can also select “I am the organizer of this event”. The request will be reviewed before any event management rights are transferred."
   },
   {
    "q": "The organizer wants an event I submitted to be changed or removed. What happens now?",
    "a": "Events may only be submitted by organizers or authorized representatives. If an event has nevertheless been submitted without authorization, the actual organizer can report it and request ownership. After review, Soul Radar can transfer management rights, correct the listing or remove it."
   }
  ]
 },
 {
  "title": "DJs & DJ Profiles",
  "items": [
   {
    "q": "I’m a DJ. How do I create a profile?",
    "a": "First create a standard Soul Radar account. You can then create and edit your DJ profile using the available profile fields."
   },
   {
    "q": "What should I include in my DJ profile?",
    "a": "Your DJ profile should focus on information that is relevant to the scene and to events: your DJ name, a short bio and, where available, a profile image, location/region and relevant links. Keep it concise and up to date."
   },
   {
    "q": "Our DJ has a Soul Radar profile. I added them to the event, so why isn’t their profile linked?",
    "a": "A profile link is only created when the existing DJ profile is actually selected and matched to the event. A name entered as free text will not be linked automatically. Check that you selected the correct profile suggestion when entering the DJ."
   },
   {
    "q": "A DJ doesn’t have a Soul Radar profile yet. Can I still add them to an event?",
    "a": "Yes. DJs without a Soul Radar profile can still be listed in the line-up as free text. Their name simply won’t be clickable. If an existing profile is later selected correctly, the profile link can be added."
   },
   {
    "q": "Can someone else create a DJ profile for me?",
    "a": "A personal DJ profile should normally be controlled by the DJ themselves. Event creators can list DJs in a line-up, but should not create or manage a personal profile on someone else’s behalf without their permission."
   },
   {
    "q": "Can I edit or delete my DJ profile later?",
    "a": "Yes. You can edit your own DJ profile from your profile settings. If the profile is already linked to existing events, specific rules may apply when you delete it."
   }
  ]
 },
 {
  "title": "“I’m going”, Saved Events & Calendar",
  "items": [
   {
    "q": "What is the “I’m going” button for?",
    "a": "“I’m going” lets you show that you plan to attend an event. It’s an active attendance marker, not just a way to bookmark something. It can also show other users that people in the community are planning to be there."
   },
   {
    "q": "What’s the difference between “I’m going” and saving an event?",
    "a": "“I’m going” means you’re planning to attend. Saving an event simply means you’re interested and want to find it again later. So you can save an event without committing to going."
   },
   {
    "q": "Can I remove my “I’m going” status?",
    "a": "Yes. If your plans change, you can remove your “I’m going” status. The option is disabled for cancelled events."
   },
   {
    "q": "Who can see that I’ve selected “I’m going”?",
    "a": "The total number of “I’m going” selections may be visible publicly. However, the attendee list showing profile pictures, names and locations is only available to signed-in Soul Radar users. Visitors who are not signed in cannot access this personal information."
   },
   {
    "q": "Where can I find my saved events?",
    "a": "You’ll find your saved events in your personal account area or saved-events list."
   },
   {
    "q": "How do I add an event to my calendar?",
    "a": "Open the Event Detail Page and use the calendar option. Soul Radar provides an ICS calendar file that you can import into most common calendar apps."
   },
   {
    "q": "Wird mein Kalendereintrag automatisch aktualisiert, wenn sich das Event ändert?",
    "a": "No. An imported ICS file is not permanently synced with Soul Radar. If an event changes, is postponed or is cancelled, check your calendar entry and update it if necessary. Soul Radar will notify users who saved the event or selected “I’m going”, according to their notification settings."
   },
   {
    "q": "Can I share events with friends?",
    "a": "Yes. Use the event’s share function or share the event link through the apps and services available on your device."
   }
  ]
 },
 {
  "title": "Messages & Community",
  "items": [
   {
    "q": "Can I chat with other users?",
    "a": "Yes, where messaging is available. You can communicate with other users through the designated messaging areas. Soul Radar is primarily an event platform, though, rather than a traditional group-chat service."
   },
   {
    "q": "How do I send a message?",
    "a": "Open the user’s profile or the relevant messaging area and select the option to send a message. Whether you can message someone may depend on their profile and privacy settings."
   },
   {
    "q": "How do I delete messages?",
    "a": "If you delete a conversation, it is only removed from your own message view. The conversation and its messages are not deleted from the other person’s account."
   },
   {
    "q": "Can I report unwanted messages or users?",
    "a": "Yes. You can use the report function to flag spam, harassment, fake profiles or other problematic content. A report does not automatically result in a ban; it will be reviewed."
   },
   {
    "q": "Can I block other users?",
    "a": "Yes. Users you block can no longer contact you directly. You’ll find the block option in the relevant menu on their profile or in the messaging area."
   }
  ]
 },
 {
  "title": "Problems, Reports & Support",
  "items": [
   {
    "q": "An event contains incorrect information. How do I report it?",
    "a": "Use the report or contact option on the event and explain as clearly as possible which information is incorrect. A link to an official source will help us review it."
   },
   {
    "q": "I can see the same event twice. What should I do?",
    "a": "Report the duplicate. Soul Radar can then check which listing is complete and up to date and remove the duplicate entry."
   },
   {
    "q": "An event is missing. What can I do?",
    "a": "If you are not the organizer or authorized to submit the event, you cannot add it yourself. You can, however, tell the organizer about Soul Radar and share the event with friends through other channels."
   },
   {
    "q": "A feature isn’t working for me. What should I check first?",
    "a": "Refresh the page, check your internet connection and make sure you’re signed in if the feature requires an account. Also check whether active filters or permissions are affecting the feature. If the problem persists, report it with a short description and, if possible, include your device, browser/app version and the steps that lead to the issue."
   },
   {
    "q": "How can I contact Soul Radar if I need help?",
    "a": "Use the Help section on Soul Radar. You’ll find the FAQ first, followed by a support form for event issues, account questions, DJ profiles, technical problems and other enquiries. You can also find the general contact email address in the Legal Notice."
   }
  ]
 },
 {
  "title": "Content, Safety & Privacy",
  "items": [
   {
    "q": "Is all information on Soul Radar guaranteed to be accurate?",
    "a": "No. Soul Radar reviews submitted content, but cannot guarantee that information will not change after publication. If you’re travelling a long way or relying on important details, always check the organizer’s official information as well."
   },
   {
    "q": "Can I upload someone else’s flyers or images?",
    "a": "Not unless you have the right to use them. When you submit an event, you confirm that you are the organizer or an authorized representative and that you are permitted to use the uploaded content for this purpose. Only upload the official event flyer, or other event content you are authorized to use."
   },
   {
    "q": "What content is not allowed on Soul Radar?",
    "a": "Content that is not allowed includes spam, deliberately false or misleading information, unlawful content, misuse of profiles, and content that threatens, harms or harasses other people. The binding rules are set out in the Terms of Use and any applicable community rules."
   },
   {
    "q": "Where can I find information about privacy and data protection?",
    "a": "Soul Radar’s Privacy Policy explains what personal data is processed, why it is processed, how long it is retained and what rights you have."
   },
   {
    "q": "Can I use Soul Radar without showing my real name publicly?",
    "a": "Only information needed for the relevant feature should be shown publicly. Your account and privacy settings make clear whether a real name is required and which profile details are visible to others."
   }
  ]
 },
 {
  "title": "Top Events & Event Archive",
  "items": [
   {
    "q": "What are “Top Events”?",
    "a": "“Top Events” ranks the ten most popular completed events on Soul Radar, based on the final number of “I’m going” selections. You can switch the ranking between “This Year” and “All Time”."
   },
   {
    "q": "Which events qualify for the Top 10?",
    "a": "Only events that actually took place and have ended are eligible. Cancelled events are excluded. For postponed events, the replacement date only counts once the event has actually taken place."
   },
   {
    "q": "Why isn’t the ranking called “Most Visited Events”?",
    "a": "Soul Radar does not track actual attendance or ticket scans. The ranking is based solely on “I’m going” selections, so it reflects popularity within Soul Radar rather than real-world attendance."
   },
   {
    "q": "Where can I find older events?",
    "a": "Below the Top 10 ranking, select “View all past events” to open the Event Archive. There you can browse events that actually took place and filter them by available criteria such as year, location, event type and music style."
   },
   {
    "q": "SOUL RADAR · FAQ",
    "a": ""
   }
  ]
 }
];
export const FAQ_INTRO_DE = "Alles, was du über Konten, Events, DJs, „I’m going“, Kalender, Nachrichten, Support, Top Events und das Event Archive wissen musst.";
export const FAQ_DE = [
 {
  "title": "Soul Radar und dein Konto nutzen",
  "items": [
   {
    "q": "Brauche ich ein Konto, um Soul Radar zu nutzen?",
    "a": "Nein. Du kannst Soul Radar durchsuchen und Events entdecken, ohne ein Konto zu haben. Ein Konto brauchst du nur für persönliche Funktionen wie das Speichern von Events, die Nutzung von „I'm going“, das Einreichen eigener Events, das Erstellen eines DJ-Profils oder das Senden von Nachrichten."
   },
   {
    "q": "Wie registriere ich mich bei Soul Radar?",
    "a": "Öffne die Registrierungsseite im Bereich Konto/Profil und folge den Schritten zur Anmeldung. Sobald du registriert bist, kannst du deine persönlichen Funktionen und Profile verwalten."
   },
   {
    "q": "Was brauche ich, um mich zu registrieren?",
    "a": "Du brauchst eine gültige E-Mail-Adresse und die während der Registrierung abgefragten Informationen. Nutze eine E-Mail-Adresse, auf die du auch künftig Zugriff hast, damit du wichtige Nachrichten zu deinem Konto oder eingereichten Events nicht verpasst."
   },
   {
    "q": "Muss ich bei der Registrierung die Nutzungsbedingungen und Datenschutzerklärung akzeptieren?",
    "a": "Ja. Du kannst die Registrierung erst abschließen, nachdem du den Nutzungsbedingungen aktiv zugestimmt und die Datenschutzerklärung zur Kenntnis genommen hast. Das Kontrollkästchen ist nicht vorab ausgewählt."
   },
   {
    "q": "Warum sollte ich ein Konto erstellen?",
    "a": "Mit einem Konto holst du mehr aus Soul Radar heraus: Du kannst Events speichern, die dich interessieren, Events mit „I'm going“ markieren, eigene Events einreichen und verwalten und, falls verfügbar, Nachrichten austauschen. DJs können außerdem ihr eigenes DJ-Profil erstellen."
   },
   {
    "q": "Ich habe mein Passwort vergessen. Was soll ich tun?",
    "a": "Nutze die Option zum Zurücksetzen des Passworts auf der Anmeldeseite. Wir senden dir die nächsten Schritte an die E-Mail-Adresse, die mit deinem Konto verknüpft ist."
   },
   {
    "q": "Kann ich meine E-Mail-Adresse oder Profildetails ändern?",
    "a": "Ja. Du kannst bearbeitbare Konto- und Profildetails in deinen Einstellungen oder im Profil-Editor aktualisieren. Wenn sich etwas aus Sicherheitsgründen nicht direkt ändern lässt, wende dich bitte an den Support."
   },
   {
    "q": "Wie lösche ich mein Konto?",
    "a": "Die Löschoption findest du in deinen Profileinstellungen. Nachdem du sie ausgewählt hast, wirst du gebeten zu bestätigen, dass du dein Konto dauerhaft löschen möchtest. Dein Profil, gespeicherte Events und deine „I'm going“-Aktivität werden entfernt. Bereits veröffentlichte Events bleiben auf Soul Radar erhalten."
   },
   {
    "q": "Was passiert mit meinen Daten, wenn ich mein Konto lösche?",
    "a": "Deine persönlichen Konto- und Profildaten werden gelöscht oder anderweitig gemäß den geltenden Datenschutzregeln behandelt. Veröffentlichte Events bleiben Teil der Event-Historie. Ein mit deinem Konto verknüpftes DJ-Profil wird deaktiviert; frühere Event-Credits können erhalten bleiben, allerdings ohne aktive Profilverknüpfung. Details findest du in der Datenschutzerklärung."
   }
  ]
 },
 {
  "title": "Events finden & entdecken",
  "items": [
   {
    "q": "Wofür sind die Buttons unter der Suchleiste da?",
    "a": "Mit den Quick-Filtern kannst du die Eventliste sofort eingrenzen. Sie sind nach Zweck gruppiert: Zeit, Ort, Event-Typ und Musikstil — zum Beispiel „This weekend“, „Near me“, „Alldayer / Allnighter / Weekender“ und „Northern Soul / Modern Soul“. Aktive Filter werden klar angezeigt und können jederzeit entfernt werden."
   },
   {
    "q": "Wie suche ich nach einem bestimmten Event?",
    "a": "Nutze die Suchleiste und gib den Eventnamen, den Ort, den Veranstalter oder einen anderen passenden Suchbegriff ein. Danach kannst du die Filter verwenden, um die Ergebnisse weiter einzugrenzen."
   },
   {
    "q": "Warum sehe ich bestimmte Events nicht?",
    "a": "Prüfe zuerst deine aktiven Filter, den ausgewählten Zeitraum und gegebenenfalls deine Entfernungseinstellung. Eingereichte Events werden erst sichtbar, sobald sie freigegeben wurden. Abgesagte oder vergangene Events können je nach Ansicht auch anders dargestellt oder ausgeblendet sein."
   },
   {
    "q": "Woran erkenne ich, ob ein Event abgesagt oder verschoben wurde?",
    "a": "Abgesagte Events sind klar mit „Cancelled“ gekennzeichnet und optisch ausgegraut. Verschobene Events sind mit „Postponed“ markiert. Sobald ein neues Datum bestätigt und hinzugefügt wurde, wird auch dieses deutlich angezeigt."
   },
   {
    "q": "Kann ich vergangene Events ansehen?",
    "a": "Ja. Events, die stattgefunden haben, bleiben im Event Archive verfügbar, wo du vergangene Events durchsuchen und filtern kannst. Abgesagte Events sind dort nicht als tatsächlich stattgefundene Events enthalten."
   }
  ]
 },
 {
  "title": "Events einreichen",
  "items": [
   {
    "q": "Wie reiche ich ein Event ein?",
    "a": "Nur Veranstalter oder von ihnen autorisierte Personen dürfen Events einreichen. Melde dich an, wähle „Submit Event“ und gib alle erforderlichen Angaben ein, darunter den Eventnamen, das Datum, die Uhrzeit, den Ort, die Beschreibung und den Flyer. Bevor du das Event abschickst, musst du bestätigen, dass du der Veranstalter bist oder von ihm autorisiert wurdest, dass die Angaben nach bestem Wissen korrekt sind und dass du die Erlaubnis hast, die hochgeladenen Inhalte zu verwenden. Erst dann kann das Event zur Prüfung eingereicht werden."
   },
   {
    "q": "Brauche ich ein spezielles Veranstalterprofil?",
    "a": "Nein. Du brauchst kein spezielles Veranstalterkonto. Ein normales Soul Radar Konto reicht aus. Beim Einreichen eines Events musst du jedoch bestätigen, dass du der Veranstalter bist oder vom Veranstalter autorisiert wurdest, es einzureichen."
   },
   {
    "q": "Ich bin nicht der Veranstalter, kenne aber ein Event in meiner Nähe, das ich hinzufügen möchte. Kann ich es einreichen?",
    "a": "Nein. Events dürfen nur vom Veranstalter oder von einer von ihm autorisierten Person eingereicht werden. Wenn du ein Event entdeckt hast, kannst du es trotzdem mit anderen teilen oder den Veranstalter auf Soul Radar hinweisen."
   },
   {
    "q": "Ich bin nicht der Veranstalter, habe das Event aber trotzdem eingereicht. Ist das erlaubt?",
    "a": "Nein. Beim Einreichen eines Events musst du ausdrücklich bestätigen, dass du der Veranstalter bist oder zur Einreichung autorisiert wurdest. Nicht autorisierte Einreichungen können abgelehnt oder entfernt werden."
   },
   {
    "q": "Warum muss ich einen Flyer hochladen?",
    "a": "Für jedes Event auf Soul Radar ist ein Flyer erforderlich. Er macht Events auf einen Blick erkennbar und ist gerade in der Soul-Szene ein wichtiger Teil der Eventkultur. Bitte lade den offiziellen Flyer oder den Flyer hoch, der tatsächlich zur Bewerbung des Events verwendet wird. Die Informationen auf dem Flyer ersetzen nicht die Eventdetails, die in den entsprechenden Feldern eingetragen werden."
   },
   {
    "q": "Was ist, wenn es keinen Flyer gibt?",
    "a": "Derzeit kann ein Event nicht ohne Flyer eingereicht werden. Bitte warte, bis ein offizieller Flyer oder der für das Event verwendete Flyer verfügbar ist, bevor du es einreichst."
   },
   {
    "q": "Welche Informationen muss ein Event enthalten?",
    "a": "Mindestens braucht ein Event einen klaren Namen, das Datum, den Ort und die wichtigsten Zeiten, die Besucher kennen müssen. Du solltest außerdem eine kurze Beschreibung, den Flyer, den Veranstalter, DJs, Ticket- oder Eintrittsdetails und, falls verfügbar, einen offiziellen Link mit weiteren Informationen angeben."
   },
   {
    "q": "Kann ich mehrere Termine für eine Eventreihe hinzufügen?",
    "a": "Ja. Jeder bestätigte Termin sollte als separates Event hinzugefügt werden. Für einen Weekender kannst du außerdem ein Start- und Enddatum sowie Start- und Endzeiten angeben, damit mehrtägige Events korrekt angezeigt werden."
   },
   {
    "q": "Mein Event findet dieses Jahr wieder statt. Kann ich es erneut einreichen?",
    "a": "Ja. Erstelle ein neues Event für das neue Datum oder nutze eine vorhandene Wiederverwendungs-/Duplizieren-Option, falls eine verfügbar ist. Prüfe unbedingt Datum, Uhrzeit, Venue, DJs, Beschreibung und Flyer. Übernimm nicht einfach die Angaben vom letzten Jahr, ohne sie zu prüfen."
   },
   {
    "q": "Kann ich dasselbe Event mehrmals einreichen?",
    "a": "Nein. Für dasselbe Eventdatum sollte es nur einen Eintrag geben. Soul Radar kann beim Einreichen ein mögliches Duplikat markieren. Prüfe zuerst den vorgeschlagenen Treffer; die Warnung verhindert nicht automatisch, dass du fortfährst."
   },
   {
    "q": "Kann ich einen Ticketlink oder eine Event-Website hinzufügen?",
    "a": "Ja, wenn das Einreichungsformular dafür ein Feld enthält. Verwende nach Möglichkeit den offiziellen Ticket- oder Event-Link statt Weiterleitungen oder irreführender Links."
   },
   {
    "q": "Kann ich ein Event einreichen, bevor alle Details bestätigt sind?",
    "a": "Nur wenn die wichtigsten Details bereits bestätigt sind. Datum, Ort und andere zentrale Angaben dürfen nicht spekulativ sein. Optionale Details kannst du später ergänzen. Ein Flyer ist außerdem erforderlich, bevor das Event eingereicht werden kann."
   },
   {
    "q": "Gibt es spezielle Felder für Weekender, Live Show oder Record Fair?",
    "a": "Ja. Weekender enthalten ein zusätzliches Enddatum-Feld. „Artists / Live Acts“ erscheint nur, wenn der Eventtyp „Live Show“ ist. Für einen „Record Fair“ kannst du außerdem Registrierungsangaben hinzufügen: eine E-Mail-Adresse oder URL sowie ein Freitextfeld, in dem du erklärst, wie man sich registriert."
   }
  ]
 },
 {
  "title": "Überprüfung & Veröffentlichung",
  "items": [
   {
    "q": "Warum wurde mein Event noch nicht veröffentlicht?",
    "a": "Neu eingereichte Events werden vor der Veröffentlichung überprüft. So bleibt die Qualität der Eventinformationen hoch und doppelte Einträge, Spam und falsche Angaben werden reduziert. Während die Überprüfung läuft, ist das Event öffentlich nicht sichtbar."
   },
   {
    "q": "Wie lange dauert die Freigabe eines Events?",
    "a": "Die Freigabe erfolgt nicht unbedingt sofort. Soul Radar versucht, Events so schnell wie möglich zu prüfen, kann aber keine bestimmte Bearbeitungszeit garantieren. Bitte reiche dein Event nach Möglichkeit frühzeitig ein."
   },
   {
    "q": "Kann mein Event abgelehnt werden?",
    "a": "Ja. Ein Event kann abgelehnt werden, wenn Angaben unvollständig oder eindeutig falsch sind, das Event ein Duplikat ist, es nicht zu Soul Radars Schwerpunkt passt oder die Einsendung Spam oder andere problematische Inhalte enthält. Wenn möglich, wird dir mitgeteilt, was korrigiert werden muss."
   },
   {
    "q": "Kann ich ein abgelehntes Event korrigieren und erneut einreichen?",
    "a": "Ja, solange der Ablehnungsgrund behoben werden kann. Korrigiere die betreffenden Angaben und reiche das Event erneut zur Prüfung ein."
   },
   {
    "q": "Warum werden Events moderiert?",
    "a": "Die Moderation hilft sicherzustellen, dass Nutzer Eventinformationen sehen, die möglichst zuverlässig sind. Sie ist jedoch keine Garantie dafür, dass alle Angaben über die Zeit hinweg korrekt bleiben. Veranstalter und autorisierte Einreicher sollten Änderungen daher zeitnah aktualisieren."
   }
  ]
 },
 {
  "title": "Bearbeiten, verschieben oder absagen deiner Events",
  "items": [
   {
    "q": "Kann ich ein Event bearbeiten?",
    "a": "Ja. Wenn du das Event erstellt hast und die entsprechenden Berechtigungen hast, kannst du es in deinem Event-Management-Bereich bearbeiten. Größere Änderungen können erneut geprüft werden, bevor sie öffentlich sichtbar werden."
   },
   {
    "q": "Wie lösche ich mein Event?",
    "a": "Öffne das Event in deinem Event-Management-Bereich und nutze die Löschfunktion. Wenn das Event bereits veröffentlicht wurde und nicht mehr stattfindet, ist es meist besser, es als “Cancelled” zu markieren, statt es komplett zu löschen. So können Nutzer, die das Event gespeichert haben, sehen, was passiert ist."
   },
   {
    "q": "Mein Event wurde abgesagt. Was soll ich tun?",
    "a": "Markiere das Event als “Cancelled”, statt es einfach zu löschen. So ist sofort klar, dass das Event nicht mehr stattfindet. “I'm going” ist für abgesagte Events deaktiviert."
   },
   {
    "q": "Mein Event wurde verschoben. Was soll ich tun?",
    "a": "Nutze “Postpone Event / Postponed”. Du kannst ein neues Datum eingeben, wenn eines bestätigt wurde, musst aber noch keines haben. Bis ein neues Datum bekannt ist, bleibt das Event als “Postponed” markiert und “I'm going” ist deaktiviert. Sobald das Ersatzdatum bestätigt ist, kannst du die Eventdetails aktualisieren."
   },
   {
    "q": "Ich habe kein Event erstellt, aber falsche Informationen entdeckt. Was kann ich tun?",
    "a": "Nutze die Meldefunktion und erkläre so klar wie möglich, welche Informationen falsch sind. Wenn du der tatsächliche Organisator bist, kannst du auch “I am the organizer of this event” auswählen. Der Antrag wird geprüft, bevor eventuelle Event-Management-Rechte übertragen werden."
   },
   {
    "q": "Der Organisator möchte, dass ein von mir eingereichtes Event geändert oder entfernt wird. Was passiert jetzt?",
    "a": "Events dürfen nur von Organisatoren oder autorisierten Vertretern eingereicht werden. Wenn ein Event dennoch ohne Autorisierung eingereicht wurde, kann der tatsächliche Organisator es melden und die Übernahme beantragen. Nach der Prüfung kann Soul Radar die Management-Rechte übertragen, den Eintrag korrigieren oder ihn entfernen."
   }
  ]
 },
 {
  "title": "DJs & DJ-Profile",
  "items": [
   {
    "q": "Ich bin DJ. Wie erstelle ich ein Profil?",
    "a": "Erstelle zuerst ein normales Soul Radar-Konto. Danach kannst du dein DJ-Profil mit den verfügbaren Profilfeldern anlegen und bearbeiten."
   },
   {
    "q": "Was sollte ich in mein DJ-Profil aufnehmen?",
    "a": "Dein DJ-Profil sollte sich auf Informationen konzentrieren, die für die Szene und für Events relevant sind: dein DJ-Name, eine kurze Bio und, falls vorhanden, ein Profilbild, Standort/Region und passende Links. Halte es knapp und aktuell."
   },
   {
    "q": "Unser DJ hat ein Soul Radar-Profil. Ich habe ihn zum Event hinzugefügt – warum ist sein Profil nicht verlinkt?",
    "a": "Ein Profil-Link wird nur erstellt, wenn das vorhandene DJ-Profil tatsächlich ausgewählt und dem Event zugeordnet wurde. Ein als Freitext eingegebener Name wird nicht automatisch verlinkt. Prüfe, ob du beim Eingeben des DJs den richtigen Profilvorschlag ausgewählt hast."
   },
   {
    "q": "Ein DJ hat noch kein Soul Radar-Profil. Kann ich ihn trotzdem zu einem Event hinzufügen?",
    "a": "Ja. DJs ohne Soul Radar-Profil können trotzdem als Freitext im Line-up aufgeführt werden. Ihr Name ist dann einfach nicht anklickbar. Wenn später ein vorhandenes Profil korrekt ausgewählt wird, kann der Profil-Link ergänzt werden."
   },
   {
    "q": "Kann jemand anderes ein DJ-Profil für mich erstellen?",
    "a": "Ein persönliches DJ-Profil sollte normalerweise vom DJ selbst verwaltet werden. Event-Ersteller können DJs in ein Line-up eintragen, sollten aber nicht ohne Erlaubnis ein persönliches Profil für jemand anderen erstellen oder verwalten."
   },
   {
    "q": "Kann ich mein DJ-Profil später bearbeiten oder löschen?",
    "a": "Ja. Du kannst dein eigenes DJ-Profil in deinen Profileinstellungen bearbeiten. Wenn das Profil bereits mit bestehenden Events verlinkt ist, können beim Löschen besondere Regeln gelten."
   }
  ]
 },
 {
  "title": "“I’m going”, Saved Events & Calendar",
  "items": [
   {
    "q": "Wofür ist der Button „I’m going“ da?",
    "a": "„I’m going“ zeigt, dass du vorhast, ein Event zu besuchen. Das ist ein aktives Teilnahmezeichen und nicht nur eine Möglichkeit, etwas zu bookmarken. Es kann auch anderen Nutzer:innen zeigen, dass Leute aus der Community planen, dort zu sein."
   },
   {
    "q": "Was ist der Unterschied zwischen „I’m going“ und einem gespeicherten Event?",
    "a": "„I’m going“ bedeutet, dass du vorhast, teilzunehmen. Ein Event zu speichern bedeutet einfach, dass es dich interessiert und du es später wiederfinden möchtest. Du kannst also ein Event speichern, ohne dich festzulegen, hinzugehen."
   },
   {
    "q": "Kann ich meinen „I’m going“-Status wieder entfernen?",
    "a": "Ja. Wenn sich deine Pläne ändern, kannst du deinen „I’m going“-Status entfernen. Die Option ist für abgesagte Events deaktiviert."
   },
   {
    "q": "Wer kann sehen, dass ich „I’m going“ ausgewählt habe?",
    "a": "Die Gesamtzahl der „I’m going“-Angaben kann öffentlich sichtbar sein. Die Teilnehmerliste mit Profilbildern, Namen und Orten ist jedoch nur für angemeldete Soul Radar Nutzer:innen verfügbar. Besucher:innen, die nicht eingeloggt sind, können auf diese persönlichen Informationen nicht zugreifen."
   },
   {
    "q": "Wo finde ich meine gespeicherten Events?",
    "a": "Du findest deine gespeicherten Events in deinem persönlichen Kontobereich oder in der Liste der gespeicherten Events."
   },
   {
    "q": "Wie füge ich ein Event zu meinem Kalender hinzu?",
    "a": "Öffne die Event Detail Page und nutze die Kalender-Option. Soul Radar stellt eine ICS-Kalenderdatei bereit, die du in die meisten gängigen Kalender-Apps importieren kannst."
   },
   {
    "q": "Wird mein Kalendereintrag automatisch aktualisiert, wenn sich das Event ändert?",
    "a": "Nein. Eine importierte ICS-Datei wird nicht dauerhaft mit Soul Radar synchronisiert. Wenn sich ein Event ändert, verschoben wird oder abgesagt wird, prüfe deinen Kalendereintrag und aktualisiere ihn bei Bedarf. Soul Radar benachrichtigt Nutzer:innen, die das Event gespeichert oder „I’m going“ ausgewählt haben, entsprechend ihren Benachrichtigungseinstellungen."
   },
   {
    "q": "Kann ich Events mit Freund:innen teilen?",
    "a": "Ja. Nutze die Teilen-Funktion des Events oder teile den Event-Link über die Apps und Dienste, die auf deinem Gerät verfügbar sind."
   }
  ]
 },
 {
  "title": "Nachrichten & Community",
  "items": [
   {
    "q": "Kann ich mit anderen Nutzern chatten?",
    "a": "Ja, dort, wo Nachrichtenfunktionen verfügbar sind. Du kannst über die vorgesehenen Nachrichtenbereiche mit anderen Nutzern kommunizieren. Soul Radar ist allerdings in erster Linie eine Event-Plattform und kein klassischer Gruppenchat-Dienst."
   },
   {
    "q": "Wie sende ich eine Nachricht?",
    "a": "Öffne das Profil des Nutzers oder den passenden Nachrichtenbereich und wähle die Option zum Senden einer Nachricht. Ob du jemandem schreiben kannst, kann von dessen Profil- und Privatsphäre-Einstellungen abhängen."
   },
   {
    "q": "Wie lösche ich Nachrichten?",
    "a": "Wenn du eine Unterhaltung löschst, wird sie nur aus deiner eigenen Nachrichtenansicht entfernt. Die Unterhaltung und ihre Nachrichten werden nicht aus dem Konto der anderen Person gelöscht."
   },
   {
    "q": "Kann ich unerwünschte Nachrichten oder Nutzer melden?",
    "a": "Ja. Du kannst die Meldefunktion nutzen, um Spam, Belästigung, Fake-Profile oder andere problematische Inhalte zu melden. Eine Meldung führt nicht automatisch zu einem Bann; sie wird geprüft."
   },
   {
    "q": "Kann ich andere Nutzer blockieren?",
    "a": "Ja. Nutzer, die du blockierst, können dich dann nicht mehr direkt kontaktieren. Die Blockierfunktion findest du im jeweiligen Menü auf ihrem Profil oder im Nachrichtenbereich."
   }
  ]
 },
 {
  "title": "Probleme, Meldungen & Support",
  "items": [
   {
    "q": "Ein Event enthält falsche Informationen. Wie melde ich das?",
    "a": "Nutze die Melden- oder Kontaktfunktion beim Event und erkläre so klar wie möglich, welche Informationen falsch sind. Ein Link zu einer offiziellen Quelle hilft uns bei der Prüfung."
   },
   {
    "q": "Ich sehe dasselbe Event zweimal. Was soll ich tun?",
    "a": "Melde das doppelte Event. Soul Radar kann dann prüfen, welcher Eintrag vollständig und aktuell ist, und den doppelten Eintrag entfernen."
   },
   {
    "q": "Ein Event fehlt. Was kann ich tun?",
    "a": "Wenn du nicht der Veranstalter bist oder nicht berechtigt bist, das Event einzustellen, kannst du es nicht selbst hinzufügen. Du kannst den Veranstalter aber auf Soul Radar hinweisen und das Event über andere Kanäle mit Freund:innen teilen."
   },
   {
    "q": "Eine Funktion funktioniert bei mir nicht. Was sollte ich zuerst prüfen?",
    "a": "Lade die Seite neu, prüfe deine Internetverbindung und stelle sicher, dass du angemeldet bist, falls die Funktion ein Konto erfordert. Prüfe außerdem, ob aktive Filter oder Berechtigungen die Funktion beeinflussen. Wenn das Problem weiterhin besteht, melde es mit einer kurzen Beschreibung und gib nach Möglichkeit dein Gerät, die Browser-/App-Version und die Schritte an, die zum Problem führen."
   },
   {
    "q": "Wie kann ich Soul Radar kontaktieren, wenn ich Hilfe brauche?",
    "a": "Nutze den Hilfebereich auf Soul Radar. Dort findest du zuerst die FAQ und danach ein Support-Formular für Event-Probleme, Fragen zum Konto, DJ-Profile, technische Probleme und andere Anfragen. Die allgemeine E-Mail-Adresse findest du auch im Impressum."
   }
  ]
 },
 {
  "title": "Inhalte, Sicherheit & Datenschutz",
  "items": [
   {
    "q": "Sind alle Informationen auf Soul Radar garantiert korrekt?",
    "a": "Nein. Soul Radar prüft eingereichte Inhalte, kann aber nicht garantieren, dass sich Angaben nach der Veröffentlichung nicht mehr ändern. Wenn du eine weite Anreise hast oder auf wichtige Details angewiesen bist, prüfe immer zusätzlich die offiziellen Informationen des Veranstalters."
   },
   {
    "q": "Kann ich Flyer oder Bilder von jemand anderem hochladen?",
    "a": "Nur, wenn du das Recht dazu hast. Wenn du ein Event einreichst, bestätigst du, dass du der Veranstalter oder eine bevollmächtigte Vertretung bist und dass du die hochgeladenen Inhalte für diesen Zweck verwenden darfst. Lade nur den offiziellen Event-Flyer oder andere Event-Inhalte hoch, die du nutzen darfst."
   },
   {
    "q": "Welche Inhalte sind auf Soul Radar nicht erlaubt?",
    "a": "Nicht erlaubt sind unter anderem Spam, absichtlich falsche oder irreführende Informationen, rechtswidrige Inhalte, der Missbrauch von Profilen sowie Inhalte, die andere Menschen bedrohen, schädigen oder belästigen. Die verbindlichen Regeln stehen in den Nutzungsbedingungen und in den jeweils geltenden Community-Regeln."
   },
   {
    "q": "Wo finde ich Informationen zu Datenschutz und Datenverarbeitung?",
    "a": "Die Datenschutzerklärung von Soul Radar erklärt, welche personenbezogenen Daten verarbeitet werden, warum sie verarbeitet werden, wie lange sie gespeichert werden und welche Rechte du hast."
   },
   {
    "q": "Kann ich Soul Radar nutzen, ohne meinen echten Namen öffentlich anzuzeigen?",
    "a": "Öffentlich angezeigt werden nur Informationen, die für die jeweilige Funktion notwendig sind. In deinem Konto und in den Datenschutzeinstellungen siehst du, ob ein echter Name erforderlich ist und welche Profildetails für andere sichtbar sind."
   }
  ]
 },
 {
  "title": "Top Events & Event Archive",
  "items": [
   {
    "q": "Was sind „Top Events“?",
    "a": "„Top Events“ zeigt die zehn beliebtesten bereits stattgefundenen Events auf Soul Radar an, basierend auf der endgültigen Anzahl an „I'm going“-Auswahlen. Du kannst die Rangliste zwischen „This Year“ und „All Time“ umschalten."
   },
   {
    "q": "Welche Events qualifizieren sich für die Top 10?",
    "a": "Nur Events, die tatsächlich stattgefunden haben und beendet sind, sind berechtigt. Abgesagte Events werden ausgeschlossen. Bei verschobenen Events zählt das Ersatzdatum erst, wenn das Event tatsächlich stattgefunden hat."
   },
   {
    "q": "Warum heißt die Rangliste nicht „Most Visited Events“?",
    "a": "Soul Radar erfasst weder echte Besucherzahlen noch Ticket-Scans. Die Rangliste basiert ausschließlich auf „I'm going“-Auswahlen und spiegelt daher die Beliebtheit innerhalb von Soul Radar wider, nicht die tatsächliche Besucherzahl vor Ort."
   },
   {
    "q": "Wo finde ich ältere Events?",
    "a": "Unter der Top-10-Rangliste kannst du „View all past events“ auswählen, um das Event Archive zu öffnen. Dort kannst du nach Events stöbern, die tatsächlich stattgefunden haben, und sie nach verfügbaren Kriterien wie Jahr, Ort, Event-Typ und Musikstil filtern."
   },
   {
    "q": "SOUL RADAR · FAQ",
    "a": ""
   }
  ]
 }
];
